
import comment from '@/components/comment.vue';
import share from '@/components/share.vue'
import sideInfo from '@/components/gallery/sideInfo.vue'
import BlockUserDialog from '@/components/block/BlockUserDialog.vue'
import UnblockUserDialog from '@/components/block/UnblockUserDialog.vue'
import BlockedEmptyState from '@/components/block/BlockedEmptyState.vue'
import noContent from '@/components/noContent.vue'
import blockUserMixin from '@/mixins/blockUser'
import {
    BLOCK_ENTRY_POINT,
    getBlockedAuthorFromDetailRes,
    isBlockInteractForbidden,
    isBlockedContentHiddenByOther,
    isContentSealedOrPrivate,
    notifyApiErrorMsg,
} from '@/utils/blockUser'
import { canAuthorEditContent } from '@/utils/contentEdit'
export default {
    components: { comment, share, sideInfo, BlockUserDialog, UnblockUserDialog, BlockedEmptyState, noContent },
    mixins: [blockUserMixin],
    name: 'index',
    directives: {
        addEntry: {
            inserted(el) {
                el.querySelectorAll('a[href]').forEach(a => {
                    try {
                        const url = new URL(a.href)
                        url.searchParams.set('entry', 'discussion')
                        a.href = url.href
                    } catch {}
                })
            },
            componentUpdated(el) {
                el.querySelectorAll('a[href]').forEach(a => {
                    try {
                        const url = new URL(a.href)
                        if (!url.searchParams.has('entry')) {
                            url.searchParams.set('entry', 'discussion')
                            a.href = url.href
                        }
                    } catch {}
                })
            }
        }
    },
    head() {
        // 优化seo：动态设置title，keywords 和 description
        //  property: "og:xxxx" 是facebook分享 图谱抓取的内容
        //  name="twitter:site" twitter  图谱抓取的内容
        //fackbook分享调试器 https://developers.facebook.com/tools/debug/
        if (this.isBlockedContent || this.isEmptyContent) {
            return { title: 'XPPen Community' }
        }
        return {
            title: this.source.title,
            meta: [
                {
                    property: "og:title",
                    content: this.source.title,

                },
                {
                    property: "og:image",
                    content: this.source.face_url,

                },
                {
                    property: "og:description",
                    content: this.source.content,
                },
                {
                    property: "og:type",
                    content: 'website',
                },
                {
                    name: "twitter:title",
                    content: this.source.title,
                },
                {
                    name: "twitter:description",
                    content: this.source.content,
                },
                {
                    name: "twitter:card",
                    content: 'summary_large_image'
                },
                {
                    name: "twitter:image",
                    content: this.source.face_url,
                },
                {
                    name: 'description', content: this.source.title,
                },

            ],
        };
    },
    data() {
        return {
            source: {
                posts_vote: [],
                posts_tag: [],
                user_medal: [],
            },//数据
            fullPath: '',//上一级路由
            checkList: [],//投票选项
            isBlockedContent: false, // 详情因拉黑关系不可见
            isEmptyContent: false, // 审核未公开 / 接口失败时页内暂无内容，不走 404/500
            blockEmptyVariant: 'blocker', // blocker=拉黑者空态；hidden=被拉黑者空态
            blockTargetUserId: null,
            blockNickname: '',
            blockAvatar: '',
        };
    },
    async asyncData({ $global, params }) {
        let checkList = []
        /** 审核未公开或接口失败：页内暂无内容，禁止 error(404/500) */
        const buildEmptyState = () => ({
            isEmptyContent: true,
            isBlockedContent: false,
            source: {
                posts_vote: [],
                posts_tag: [],
                user_medal: [],
            },
            checkList: [],
        })
        /** 拉黑不可见时返回空态所需字段，避免 error(500) */
        const buildBlockedState = (res) => {
            const hiddenByOther = isBlockedContentHiddenByOther(res)
            const author = getBlockedAuthorFromDetailRes(res)
            return {
                isBlockedContent: true,
                blockEmptyVariant: hiddenByOther ? 'hidden' : 'blocker',
                // 被拉黑者不能移出对方黑名单，不传目标用户
                blockTargetUserId: hiddenByOther ? null : author.target_user_id,
                blockNickname: author.nickname,
                blockAvatar: author.avatar,
                source: {
                    uid: author.target_user_id,
                    nickname: author.nickname,
                    posts_vote: [],
                    posts_tag: [],
                    user_medal: [],
                },
                checkList: [],
            }
        }
        try {
            const res = await $global.forumDetails({ id: params.id })
            if (isBlockInteractForbidden(res)) {
                return buildBlockedState(res)
            }
            if (isContentSealedOrPrivate(res)) {
                return buildEmptyState()
            }
            if (res.code == 200) {
                if (!res.data.posts_vote) {
                    res.data.posts_vote = []
                }
                if (!res.data.posts_tag) {
                    res.data.posts_tag = []
                }
                if (!res.data.user_medal) {
                    res.data.user_medal = []
                }
                const voteCount = res.data.posts_vote_count || 0
                res.data.posts_vote.forEach(item => {
                    item.voteNum = voteCount > 0 ? item.posts_vote_user_count / voteCount * 100 : 0
                    item.is_select == 1 ? checkList.push(item.vote_id) : ''
                })
                return { source: res.data, checkList, isBlockedContent: false, isEmptyContent: false }
            }
            return buildEmptyState()
        } catch (e) {
            const body = e && e.response && e.response.data
            if (isBlockInteractForbidden(body)) {
                return buildBlockedState(body)
            }
            return buildEmptyState()
        }

    },
    computed: {
        currentUid() {
            return this.$store.state.userInfo?.userInfo?.uid || '';
        },
        /** 当前登录用户就是作者。空 id 不算自己，避免刷新后误显示拉黑/举报 */
        isOwnContent() {
            const mine = Number(this.currentUid)
            const author = Number(this.source && this.source.uid)
            return mine > 0 && mine === author
        },
        /** 看自己的详情时，有 edit_status 优先显示修改审核；没有该字段仍按 status。其他人看详情不显示修改审核 */
        reviewLabel() {
            const source = this.source || {}
            const editStatus = source.edit_status
            const hasEditStatus = editStatus !== undefined && editStatus !== null
            if (hasEditStatus) {
                if (!this.isOwnContent) return ''
                if (editStatus === 0) return this.$t('page.EDIT_CONTENT_PENDING')
                if (editStatus === -3) return this.$t('page.EDIT_CONTENT_REJECTED')
                return ''
            }
            if (source.status == 0) return this.$t('page.POST_MODERATING')
            if (source.status == -1) return this.$t('page.POST_DELETED')
            if (source.status == -2) return this.$t('page.AUDIT_NOT_PASSED')
            return ''
        },
        /** 作者且未删除时可编辑；删除态只保留删除 */
        canEditContent() {
            return this.isOwnContent && canAuthorEditContent(this.source.status)
        },
        /** 自己的帖子保留删除；对方帖子若已拉黑则隐藏更多按钮 */
        showDetailActions() {
            if (this.isBlockedContent || this.isEmptyContent) return false
            if (this.isOwnContent) return true
            return this.source.is_blocked_by_me !== 1
        },
    },
    mounted() {
        if (this.isBlockedContent || this.isEmptyContent) return
        // this.getData()
        console.log(this.$router)
          /** hwtag埋点-阅读*/
          this.$track('content_viewed', {
            'content_id': this.source.id,
            'content_type': 'discussion',
            'author_id': this.source.uid,
            'author':this.source.nickname,
            'current_view':this.source.hits
        });

    },
    filters: {
        formatDate: function (value) {//10位时间戳转换
            let date = new Date(parseInt(value) * 1000);
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let minute = date.getMinutes();
            let second = date.getSeconds();
            minute = minute < 10 ? "0" + minute : minute;
            second = second < 10 ? "0" + second : second;
            return m + "月" + d + "日 " + h + ":" + minute + ":" + second;
        }
    },
    methods: {
        async getData() {
            let res = await this.$global.forumDetails({ id: this.$route.params.id })
            if (res.code == 200) {
                if (!res.data.posts_vote) {
                    res.data.posts_vote = []
                }
                const voteCount = res.data.posts_vote_count || 0
                res.data.posts_vote.forEach(item => {
                    item.voteNum = voteCount > 0 ? item.posts_vote_user_count / voteCount * 100 : 0
                    item.is_select == 1 ? this.checkList.push(item.vote_id) : ''
                })
                this.source = res.data
            }
        },
        async likeOperation() {
            //点赞 取消点赞
            // type 1是作品点赞、取消点赞 20是教程点赞、取消点赞 7作品评论点赞、取消点赞 8教程咨询评论点赞、取消点赞 21帖子点赞 取消点赞 22 帖子评论点赞 取消点赞
            let res = await this.$global.likeaction({ "relation_id": this.source.id, "type": "21" })
            if (res.code == 200) {
                this.source.is_like = res.data.hasClick
                this.getData()
                this.$message({
                    showClose: true,
                    message: res.msg
                });
            } else {
                notifyApiErrorMsg(res, this)
            }

        },
        async collectOperation() {
            //收藏 取消收藏
            //type 1作品收藏 3资讯收藏 5活动收藏 9帖子收藏 10教程收藏
            //is_collect 0是收藏1取消收藏
            let res = await this.$global.do_collect({ "relation_id": this.source.id, "type": "9", "is_collect": this.source.is_collect })
            console.log(res, 'res')
            if (res.code == 200) {
                this.source.is_collect = !this.source.is_collect
                this.$message({
                    showClose: true,
                    message: res.msg
                });
            } else {
                notifyApiErrorMsg(res, this)
            }

        },
        async focusOn(id) {
            //关注用户
            let res = await this.$global.doFollow({ "fid": id })
            if (res.code == '200') {
                this.source.is_follow_author = 1
                this.$message(res.msg)
                return
            }
            notifyApiErrorMsg(res, this)
        },
        async unsubscribe(id) {
            //取消关注用户
            let res = await this.$global.unFollow({ "fid": id })
            if (res.code == '200') {
                this.source.is_follow_author = 0
                this.$message(res.msg)
                return
            }
            notifyApiErrorMsg(res, this)
        },
        /** 帖子详情拉黑入口，来源只传 posts；成功后留在当前页并隐藏更多操作，刷新才走空态 */
        async onClickBlockUser() {
            try {
                await this.openBlockDialog({
                    target_user_id: this.source.uid,
                    entry_point: BLOCK_ENTRY_POINT.POSTS,
                    nickname: this.source.nickname,
                    avatar: this.source.user_thumb_face_url || this.source.user_thumb_compress || this.source.face_url,
                })
                this.$set(this.source, 'is_blocked_by_me', 1)
            } catch (e) {
                // 取消、未登录或参数非法时不改页面状态
            }
        },
        goBlacklistSettings() {
            this.$router.push({ path: '/setup/blacklist' })
        },
        /** 详情拉黑空态移出黑名单后刷新以恢复内容 */
        async onClickUnblockUser() {
            if (!this.blockTargetUserId) {
                this.goBlacklistSettings()
                return
            }
            try {
                await this.openUnblockDialog({
                    target_user_id: this.blockTargetUserId,
                    nickname: this.blockNickname,
                    avatar: this.blockAvatar,
                })
                if (process.client) {
                    window.location.reload()
                }
            } catch (e) {
                // 取消或失败保持空态
            }
        },
        /** 进入现有帖子编辑页，带上帖子 id 预填并走编辑提交 */
        goEditPost() {
            this.$router.push({
                path: '/discussion/editor',
                query: { id: this.source.id },
            })
        },
        async deletePost(posts_id) {
            //删除帖子
            let res = await this.$global.postsDel({ posts_id, })
            res.code == 200 ? this.$message({
                message: res.msg,
                type: 'success'
            }) : ''
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000)
        },
        format() {
            return ''
        },
        async electionVote() {
            //选择投票
            if (this.checkList.length != 0) {
                let res = await this.$global.addPostsVoteUser({ posts_id: this.source.id, vote_id: this.checkList.join(',') })
                res.code == 200 ? this.getData() : ''
            }
            else {
                this.$message(this.$t('page.PLEASE_SELECT_VOTING_OPTION'));
            }

        },
        pictureFilter(item) {
            return item.thumb_vote_img == "" ? item.vote_img : item.humb_vote_img
        }

    }

}
